import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from 'react-router-dom';
import Home from '../../pages/Home/Home';
import Sobre from '../../pages/Sobre/Sobre';
import Servicos from '../../pages/Servicos/Servicos';
import Contato from '../../pages/Contato/Contato';
import ParticipacaoRemunerada from '../../pages/ParticipacaoRemunerada/ParticipacaoRemunerada';
import CalculadoraV2 from '../../pages/CalculadoraV2/CalculadoraV2';
import CalculadoraV1 from '../../pages/CalculadoraV1/CalculadoraV1';
import './Navbar.css';
import '../../styles.css'
import { ToastContainer } from 'react-toastify';
import Blog from "../../pages/Blog/Blog";
import News1 from "../../pages/News1/News1";
import News2 from "../../pages/News2/News2";
import News3 from "../../pages/News3/News3";
import News4 from "../../pages/News4/News4";
import News5 from "../../pages/News5/News5";
import News6 from "../../pages/News6/News6";
import News7 from "../../pages/News7/News7";
import PoliticaPrivacidade from "../../pages/PoliticaPrivacidade/PoliticaPrivacidade";


function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    isActive
      ? 'underline underline-offset-4 decoration-2 font-bold'
      : 'text-white hover:text-gray-200 transition-colors duration-200';

  const linkStyle = ({ isActive }) => isActive ? { color: '#f5be88' } : {};

  return (
    <Router>
      <nav
        className={`fixed top-0 left-0 w-screen px-8 py-2 text-base z-50 transition-all duration-300 ${scrolled ? 'shadow-xl' : 'shadow-md'}`}
        style={{
          backgroundColor: scrolled ? 'rgba(0, 46, 77, 0.98)' : 'rgba(0, 46, 77, 0.82)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
        }}
      >

        <ToastContainer position="top-right" className="z-[9999]" />
        <div className="flex">
          <div className="w-2/12 flex justify-center items-center">
            <Link to="/">
              <img className="h-16 h-sm:h-10" src="logo-objetiva2.png" alt='logo' style={{ filter: 'brightness(0) invert(1)' }} />
            </Link>
          </div>
          <div className="w-8/12 h-sm:hidden">
            <ul className="flex justify-center items-center list-none h-20 font-raleway">
              <li className="w-1/12 text-center font-semibold">
                <NavLink to="/" className={linkClass} style={linkStyle}>Home</NavLink>
              </li>
              <li className="w-2/12 text-center font-semibold">
                <NavLink to="/sobre" className={linkClass} style={linkStyle}>Quem somos</NavLink>
              </li>
              <li className="w-3/12 text-center font-semibold">
                <NavLink to="/participacaoRemunerada" className={linkClass} style={linkStyle}>Programa de parceria remunerada</NavLink>
              </li>
              <li className="w-3/12 text-center font-semibold">
                <NavLink to="/servicos" className={linkClass} style={linkStyle}>Intermediação de cotas canceladas</NavLink>
              </li>
              <li className="w-2/12 text-center font-semibold">
                <NavLink to="/contato" className={linkClass} style={linkStyle}>Contato</NavLink>
              </li>
              <li className="w-1/12 text-center font-semibold">
                <NavLink to="https://objetivascp.com.br/login" target="_blank" className={linkClass} style={linkStyle}> SCP</NavLink>
              </li>
            </ul>
          </div>
          <div className="hidden h-sm:w-10/12 h-sm:block">
            <ul className="flex justify-center items-center list-none h-20 font-raleway">
              <li className="w-1/6 text-center flex justify-center items-center"><Link to="/"><img src="home.png" alt="logo" /></Link></li>
              <li className="w-1/6 text-center flex justify-center items-center"><Link to="/sobre"><img src="company.png" alt="logo" /></Link></li>
              <li className="w-1/6 text-center flex justify-center items-center"><Link to="/participacaoRemunerada"><img src="hands.png" alt="logo" /></Link></li>
              <li className="w-1/6 text-center flex justify-center items-center"><Link to="/servicos"><img src="people-icon.png" alt="logo" /></Link></li>
              <li className="w-1/6 text-center flex justify-center items-center"><Link to="/contato"><img src="contacts.png" alt="logo" /></Link></li>
              <li className="w-1/6 text-center flex justify-center items-center"><a href="https://objetivascp.com.br/login" target="_blank" rel="noreferrer"><img src="scp.png" alt="logo" /></a></li>
            </ul>
          </div>
        </div>
      </nav>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/participacaoRemunerada" element={<ParticipacaoRemunerada />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/calculadoraV2" element={<CalculadoraV2 />} />
        <Route path="/calculadoraV1" element={<CalculadoraV1 />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/news1" element={<News1 />} />
        <Route path="/news2" element={<News2 />} />
        <Route path="/news3" element={<News3 />} />
        <Route path="/news4" element={<News4 />} />
        <Route path="/news5" element={<News5 />} />
        <Route path="/news6" element={<News6 />} />
        <Route path="/news7" element={<News7 />} />
        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
      </Routes>
    </Router>
  );
}

export default Navbar;
